  document.addEventListener('rebuy:reorderLandingPage.ready', function(){
    setTimeout(()=>{
    if(Rebuy.ReorderLandingPage){

      // Remove null products and tagged products from previous order products
      const filteredProducts = Rebuy.ReorderLandingPage.products.filter(prod => {
        if (prod == null) return false;
        if (prod.tags.includes('pre-purchase-hide')) return false;
        return true;
      });
      Rebuy.ReorderLandingPage.products = filteredProducts;

      // Remove tagged products from cart
      Rebuy.Cart.cart.items.forEach(item => {
        if (item.final_price === 0 || item.product.tags.includes('pre-purchase-hide')) {
          Rebuy.Cart.removeItem(item)
        }
      })
    }
      }, 2500)
  });